import * as React from 'react';
import {Button, Grid, TextField} from '@material-ui/core';
import {API} from "aws-amplify";
import JsonRenderComponent from "../../../../utils/JsonRenderComponent";
import {LoadingSpinner} from "../../../../utils/LoadingSpinner";
import {Alert} from "@material-ui/lab";

interface IProps {
    data?: any
}

interface IState {
    errorMessage: string
    isLoading: boolean
    prescriptionId: string
    response: any
}

class SearchPrescriptionSection extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            errorMessage: '',
            isLoading: false,
            prescriptionId: '',
            response: ''
        };

        this.setPrescriptionId = this.setPrescriptionId.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public render() {
        return (
            <Grid
                container
                direction="column"
                justify="center"
                alignItems="center"
                spacing={3}
            >
                <Grid item xs>
                    <TextField
                        style={{width: 400}}
                        label="Prescription Id"
                        variant="outlined"
                        value={ this.state.prescriptionId }
                        onChange={ this.setPrescriptionId }
                    />
                </Grid>

                <Grid item xs>
                    <Button variant="outlined" color="default" onClick={this.handleSubmit}>
                        Search Prescription
                    </Button>
                </Grid>

                { this.state.isLoading && <LoadingSpinner/> }

                { this.state.errorMessage &&
                    <Alert variant="filled" severity="info">
                        Error encountered: { this.state.errorMessage }
                    </Alert>
                }

                { this.state.response &&
                    <div>
                        <br/>
                        <h4>Prescription Details</h4>
                        <p style={{
                            border: '3px solid lightgray',
                            padding: '5px',
                            whiteSpace: "pre-wrap",
                            wordBreak: "normal",
                            wordWrap: "break-word"
                        }}>
                            <JsonRenderComponent jsonObject={ this.state.response } printHtml={ false }/>
                        </p>
                    </div>
                }
            </Grid>
        );
    }

    private setPrescriptionId(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({ prescriptionId: event.target.value })
    }

    private handleSubmit() {
        this.setState({ isLoading: true });

        const apiName = 'ApaqPortalAPI';
        const path = '/prescription/search?prescriptionId=' + this.state.prescriptionId;

        API.get(apiName, path, {}).then((searchPrescriptionResponse: any) => {
            console.log(searchPrescriptionResponse);

            this.setState({ response: searchPrescriptionResponse });
        }).catch((error) => {
           console.log(error);

            this.setState({ errorMessage: error.response.data.message });
        });
        this.setState({ isLoading: false });
    }
}

export default SearchPrescriptionSection